import { PropertyFieldReadOnlyViewModel } from "./property-field-read-only.view-model";

export enum PropertySectionKind {
  Section = "section",
  Security = "security",
  Unit = "unit",
}

export type PropertySectionViewModel = {
  kind: PropertySectionKind;
  title: string;
  fields: PropertyFieldReadOnlyViewModel[];
};
